// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file crm/v1/account_identity_document.proto (package crm.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file crm/v1/account_identity_document.proto.
 */
export const file_crm_v1_account_identity_document: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_types]);

/**
 * AccountIdentityDocument message definition
 *
 * @generated from message crm.v1.AccountIdentityDocument
 */
export type AccountIdentityDocument = Message<"crm.v1.AccountIdentityDocument"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID account_individual_details_id = 2;
   */
  accountIndividualDetailsId?: ID;

  /**
   * @generated from field: crm.v1.IdentityDocumentType document_type = 3;
   */
  documentType: IdentityDocumentType;

  /**
   * @generated from field: string document_number = 4;
   */
  documentNumber: string;

  /**
   * @generated from field: string issuing_state = 5;
   */
  issuingState: string;

  /**
   * @generated from field: google.protobuf.Timestamp issue_date = 6;
   */
  issueDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expiration_date = 7;
   */
  expirationDate?: Timestamp;

  /**
   * @generated from field: types.Base base = 8;
   */
  base?: Base;
};

/**
 * Describes the message crm.v1.AccountIdentityDocument.
 * Use `create(AccountIdentityDocumentSchema)` to create a new message.
 */
export const AccountIdentityDocumentSchema: GenMessage<AccountIdentityDocument> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_identity_document, 0);

/**
 * Request/Response messages for AccountIdentityDocument queries
 *
 * @generated from message crm.v1.GetAccountIdentityDocumentRequest
 */
export type GetAccountIdentityDocumentRequest = Message<"crm.v1.GetAccountIdentityDocumentRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.GetAccountIdentityDocumentRequest.
 * Use `create(GetAccountIdentityDocumentRequestSchema)` to create a new message.
 */
export const GetAccountIdentityDocumentRequestSchema: GenMessage<GetAccountIdentityDocumentRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_identity_document, 1);

/**
 * @generated from message crm.v1.GetAccountIdentityDocumentResponse
 */
export type GetAccountIdentityDocumentResponse = Message<"crm.v1.GetAccountIdentityDocumentResponse"> & {
  /**
   * @generated from field: crm.v1.AccountIdentityDocument account_identity_document = 1;
   */
  accountIdentityDocument?: AccountIdentityDocument;
};

/**
 * Describes the message crm.v1.GetAccountIdentityDocumentResponse.
 * Use `create(GetAccountIdentityDocumentResponseSchema)` to create a new message.
 */
export const GetAccountIdentityDocumentResponseSchema: GenMessage<GetAccountIdentityDocumentResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_identity_document, 2);

/**
 * @generated from message crm.v1.ListAccountIdentityDocumentsRequest
 */
export type ListAccountIdentityDocumentsRequest = Message<"crm.v1.ListAccountIdentityDocumentsRequest"> & {
  /**
   * @generated from field: crm.v1.ListAccountIdentityDocumentsFilter filter = 1;
   */
  filter?: ListAccountIdentityDocumentsFilter;

  /**
   * @generated from field: repeated crm.v1.AccountIdentityDocumentSortOption sorting = 2;
   */
  sorting: AccountIdentityDocumentSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message crm.v1.ListAccountIdentityDocumentsRequest.
 * Use `create(ListAccountIdentityDocumentsRequestSchema)` to create a new message.
 */
export const ListAccountIdentityDocumentsRequestSchema: GenMessage<ListAccountIdentityDocumentsRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_identity_document, 3);

/**
 * @generated from message crm.v1.ListAccountIdentityDocumentsFilter
 */
export type ListAccountIdentityDocumentsFilter = Message<"crm.v1.ListAccountIdentityDocumentsFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue search_term = 2;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.ListAccountIdentityDocumentsFilter.
 * Use `create(ListAccountIdentityDocumentsFilterSchema)` to create a new message.
 */
export const ListAccountIdentityDocumentsFilterSchema: GenMessage<ListAccountIdentityDocumentsFilter> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_identity_document, 4);

/**
 * @generated from message crm.v1.ListAccountIdentityDocumentsResponse
 */
export type ListAccountIdentityDocumentsResponse = Message<"crm.v1.ListAccountIdentityDocumentsResponse"> & {
  /**
   * @generated from field: repeated crm.v1.AccountIdentityDocument account_identity_documents = 1;
   */
  accountIdentityDocuments: AccountIdentityDocument[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message crm.v1.ListAccountIdentityDocumentsResponse.
 * Use `create(ListAccountIdentityDocumentsResponseSchema)` to create a new message.
 */
export const ListAccountIdentityDocumentsResponseSchema: GenMessage<ListAccountIdentityDocumentsResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_identity_document, 5);

/**
 * Input messages
 *
 * @generated from message crm.v1.AccountIdentityDocumentInput
 */
export type AccountIdentityDocumentInput = Message<"crm.v1.AccountIdentityDocumentInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID account_individual_details_id = 2;
   */
  accountIndividualDetailsId?: ID;

  /**
   * @generated from field: crm.v1.IdentityDocumentType document_type = 3;
   */
  documentType: IdentityDocumentType;

  /**
   * @generated from field: string document_number = 4;
   */
  documentNumber: string;

  /**
   * @generated from field: string issuing_state = 5;
   */
  issuingState: string;

  /**
   * @generated from field: google.protobuf.Timestamp issue_date = 6;
   */
  issueDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expiration_date = 7;
   */
  expirationDate?: Timestamp;
};

/**
 * Describes the message crm.v1.AccountIdentityDocumentInput.
 * Use `create(AccountIdentityDocumentInputSchema)` to create a new message.
 */
export const AccountIdentityDocumentInputSchema: GenMessage<AccountIdentityDocumentInput> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_identity_document, 6);

/**
 * @generated from message crm.v1.AccountIdentityDocumentUpdateInput
 */
export type AccountIdentityDocumentUpdateInput = Message<"crm.v1.AccountIdentityDocumentUpdateInput"> & {
  /**
   * @generated from field: crm.v1.IdentityDocumentType document_type = 1;
   */
  documentType: IdentityDocumentType;

  /**
   * @generated from field: google.protobuf.StringValue document_number = 2;
   */
  documentNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue issuing_state = 3;
   */
  issuingState?: string;

  /**
   * @generated from field: google.protobuf.Timestamp issue_date = 4;
   */
  issueDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expiration_date = 5;
   */
  expirationDate?: Timestamp;
};

/**
 * Describes the message crm.v1.AccountIdentityDocumentUpdateInput.
 * Use `create(AccountIdentityDocumentUpdateInputSchema)` to create a new message.
 */
export const AccountIdentityDocumentUpdateInputSchema: GenMessage<AccountIdentityDocumentUpdateInput> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_identity_document, 7);

/**
 * IdentityDocumentType enum
 *
 * @generated from enum crm.v1.IdentityDocumentType
 */
export enum IdentityDocumentType {
  /**
   * @generated from enum value: IDENTITY_DOCUMENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: IDENTITY_DOCUMENT_TYPE_DRIVER_LICENSE = 1;
   */
  DRIVER_LICENSE = 1,

  /**
   * @generated from enum value: IDENTITY_DOCUMENT_TYPE_PASSPORT = 2;
   */
  PASSPORT = 2,

  /**
   * @generated from enum value: IDENTITY_DOCUMENT_TYPE_MEXICAN_MATRICULA_CONSULAR = 3;
   */
  MEXICAN_MATRICULA_CONSULAR = 3,

  /**
   * @generated from enum value: IDENTITY_DOCUMENT_TYPE_STATE_I_D = 4;
   */
  STATE_I_D = 4,

  /**
   * @generated from enum value: IDENTITY_DOCUMENT_TYPE_OTHER = 5;
   */
  OTHER = 5,
}

/**
 * Describes the enum crm.v1.IdentityDocumentType.
 */
export const IdentityDocumentTypeSchema: GenEnum<IdentityDocumentType> = /*@__PURE__*/
  enumDesc(file_crm_v1_account_identity_document, 0);

/**
 * @generated from enum crm.v1.AccountIdentityDocumentSortOption
 */
export enum AccountIdentityDocumentSortOption {
  /**
   * @generated from enum value: ACCOUNT_IDENTITY_DOCUMENT_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCOUNT_IDENTITY_DOCUMENT_SORT_OPTION_DOCUMENT_TYPE_ASC = 1;
   */
  DOCUMENT_TYPE_ASC = 1,

  /**
   * @generated from enum value: ACCOUNT_IDENTITY_DOCUMENT_SORT_OPTION_DOCUMENT_TYPE_DESC = 2;
   */
  DOCUMENT_TYPE_DESC = 2,

  /**
   * @generated from enum value: ACCOUNT_IDENTITY_DOCUMENT_SORT_OPTION_CREATED_AT_ASC = 3;
   */
  CREATED_AT_ASC = 3,

  /**
   * @generated from enum value: ACCOUNT_IDENTITY_DOCUMENT_SORT_OPTION_CREATED_AT_DESC = 4;
   */
  CREATED_AT_DESC = 4,

  /**
   * @generated from enum value: ACCOUNT_IDENTITY_DOCUMENT_SORT_OPTION_UPDATED_AT_ASC = 5;
   */
  UPDATED_AT_ASC = 5,

  /**
   * @generated from enum value: ACCOUNT_IDENTITY_DOCUMENT_SORT_OPTION_UPDATED_AT_DESC = 6;
   */
  UPDATED_AT_DESC = 6,
}

/**
 * Describes the enum crm.v1.AccountIdentityDocumentSortOption.
 */
export const AccountIdentityDocumentSortOptionSchema: GenEnum<AccountIdentityDocumentSortOption> = /*@__PURE__*/
  enumDesc(file_crm_v1_account_identity_document, 1);

/**
 * Services
 *
 * @generated from service crm.v1.AccountIdentityDocumentQueriesService
 */
export const AccountIdentityDocumentQueriesService: GenService<{
}> = /*@__PURE__*/
  serviceDesc(file_crm_v1_account_identity_document, 0);

/**
 * @generated from service crm.v1.AccountIdentityDocumentCommandsService
 */
export const AccountIdentityDocumentCommandsService: GenService<{
}> = /*@__PURE__*/
  serviceDesc(file_crm_v1_account_identity_document, 1);

